export default function Menu() {
  return <div>Issues</div>;
}